<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p><em>Meat? Really?</em></p>
<p>Starved, Uzbe swallowed it. But there was something in it. He suddenly felt so dizzy. His consciousness was fading out fast. He fell.</p>
<p>Two men emerged from the heavy mist and put him in a sack.</p>
<p>Uzbe was horrified. With his last energy, he whined:</p>
<p><em>Dad, Mom, take this nightmare away…</em></p>
<p>But would he ever wake up at all?</p>
<p>Bali, 2008, Uzbe went missing. Him and his owners, a Canadian and Balinese couple, relentlessly searched for each other, navigating their way across dog-eating world and mass culling for rabies outcry in an island where social gaps, prejudice, and cultural clashes laid in a plain sight. The journey somehow brought the best of them and those they encountered along the way.</p>
<p>Paradise can be deceiving. Hell can be uplifting. This is a tale inspired by true events that will make you wonder what should you feel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?07961076